import { ApplicationsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  GetApplicationPhasesDocument,
  JobPostingDocument,
  UpdateApplicationStatusDocument,
  UpdateApplicationStatusMutation,
  UpdateApplicationStatusMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type AtsApplicationStatus =
  UpdateApplicationStatusMutation['atsMutations']['updateAtsApplication']['application']

export const useUpdateApplicationStatus = () => {
  const [update, { loading }] = useMutation(UpdateApplicationStatusDocument, {
    extractorFn: (data: UpdateApplicationStatusMutation) => data.atsMutations.updateAtsApplication,
  })

  return {
    loading,
    updateApplicationStatus(variables: UpdateApplicationStatusMutationVariables) {
      return update({
        variables,
        refetchQueries: [
          ApplicationsDataTableDocument,
          GetApplicationPhasesDocument,
          JobPostingDocument,
        ],
      })
    },
  }
}
